"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var _default = exports.default = [{
  path: '/plant-nursery',
  name: 'plant-nursery-lots',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/lots/LotsPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/create-lot',
  name: 'plant-nursery-create-lot',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/lots/CreateLotPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/graft',
  name: 'plant-nursery-graft',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/lots/GraftLotPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/partial-graft',
  name: 'plant-nursery-partial-graft',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/lots/PartialGraftLotPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/graft-success-rate',
  name: 'plant-nursery-graft-success-rate',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/lots/GraftSuccessRatePage'));
    });
  },
  meta: {
    requiresAuth: true
  }
},
// {
//   path: '/plant-nursery/merge-lots',
//   name: 'plant-nursery-merge-lots',
//   component: () =>
//     import(
//       /* webpackChunkName: "plant-nursery-merge-lots" */
//       '@/flow/plantNursery/lots/MergeLotsPage'
//     ),
//   meta: { requiresAuth: true }
// },
{
  path: '/plant-nursery/move-lot',
  name: 'plant-nursery-move-lot',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/lots/MoveLotPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/mortality',
  name: 'plant-nursery-mortality',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/lots/LotMortalityPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
},
// {
//   path: '/plant-nursery/transfer',
//   name: 'plant-nursery-transfer',
//   component: () =>
//     import(
//       /* webpackChunkName: "plant-nursery-transfer" */
//       '@/flow/plantNursery/lots/TransferLotPage'
//     ),
//   meta: { requiresAuth: true }
// },
{
  path: '/plant-nursery/dispatch',
  name: 'plant-nursery-dispatch',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/lots/DispatchLotPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/sectors',
  name: 'plant-nursery-sectors',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/sectors/SectorsPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/varieties',
  name: 'plant-nursery-varieties',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/varieties/VarietiesPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/customers',
  name: 'plant-nursery-customers',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/customers/CustomersPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/contracts',
  name: 'plant-nursery-contracts',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/contracts/ContractsPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}, {
  path: '/plant-nursery/dashboard',
  name: 'plant-nursery-dashboard',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/flow/plantNursery/dashboard/DashboardPage'));
    });
  },
  meta: {
    requiresAuth: true
  }
}];